export enum AppType {
    Admin = '1',
    Client = '2'
}